export const JD_OKTA_CONNECTION = 'jd-okta'
export const SSO_CONNECTION_QUERY_PARAM = 'connection'
export const SSO_CONNECTION_STORAGE_KEY = 'sparkai.sso-connection'

export function isJdOktaConnectionRequested(search: string): boolean {
  return new URLSearchParams(search).get(SSO_CONNECTION_QUERY_PARAM) === JD_OKTA_CONNECTION
}

export function isJdOktaConnectionRemembered(): boolean {
  try {
    return globalThis.localStorage.getItem(SSO_CONNECTION_STORAGE_KEY) === JD_OKTA_CONNECTION
  } catch {
    return false
  }
}

export function rememberJdOktaConnection() {
  try {
    globalThis.localStorage.setItem(SSO_CONNECTION_STORAGE_KEY, JD_OKTA_CONNECTION)
  } catch {
    return
  }
}

export function clearRememberedSsoConnection() {
  try {
    globalThis.localStorage.removeItem(SSO_CONNECTION_STORAGE_KEY)
  } catch {
    return
  }
}

export function syncRememberedSsoConnection(authenticatedSub: string) {
  if (authenticatedSub.startsWith(`oidc|${JD_OKTA_CONNECTION}|`)) rememberJdOktaConnection()
  else clearRememberedSsoConnection()
}

export function getSsoConnectionLoginOptions(useJdOkta: boolean): { connection?: typeof JD_OKTA_CONNECTION } {
  return useJdOkta ? { connection: JD_OKTA_CONNECTION } : {}
}
